import { Box, Card, Text, Title } from '@nimbus-ds/components';
import { Stack } from 'commons/components';
import type {
  InterfaceNameValue,
  InterfaceNameBooleanValue,
} from 'commons/types';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import {
  Client,
  Quantity,
  QuantityValuesInterface,
  DatesValuesInterface,
  QuantityErrorsInterface,
  DatesErrorsInterface,
  Dates,
  ValueCart,
  MaxDiscountAmount,
  Active,
  LimitsSkeleton,
  ClientErrorsInterface,
  ClientValuesInterface,
} from './components';
import { DiscountCombination } from './components/DiscountCombination';
import { CouponValuesInterface } from '../../types';

export interface LimitsValuesInterface
  extends QuantityValuesInterface,
    DatesValuesInterface,
    ClientValuesInterface {
  minPrice: string;
  maxDiscountAmount: string;
  maxDiscountAmountType: 'unlimited' | 'limited';
  combinesWithOtherDiscounts: boolean;
}

export interface LimitsErrorsInterface
  extends QuantityErrorsInterface,
    DatesErrorsInterface,
    ClientErrorsInterface {
  maxDiscountAmount?: string;
}

interface LimitsProps {
  values: CouponValuesInterface;
  errors: Partial<LimitsErrorsInterface>;
  onChange: ({
    value,
    name,
  }: InterfaceNameValue | InterfaceNameBooleanValue) => void;
  showActiveInput: boolean;
  currentUses: number;
}

export function Limits({
  values,
  errors,
  onChange,
  showActiveInput,
  currentUses,
}: Readonly<LimitsProps>) {
  const t = useTranslationMarketing();

  return (
    <Card>
      <Card.Header>
        <Stack spacing="none" justify="space-between" align="center">
          <Stack spacing="tight">
            <Title as="h4">{t('coupons.couponForm.limits.title')}</Title>
          </Stack>
        </Stack>
      </Card.Header>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="6">
          <Text>{t('coupons.couponForm.limits.info')}</Text>
          <DiscountCombination values={values} onChange={onChange} />
          <Box display="flex" flexDirection="column" gap="6">
            {showActiveInput && (
              <Active value={values.active} onChange={onChange} />
            )}
            <Quantity
              values={values}
              errors={errors}
              onChange={onChange}
              currentUses={currentUses}
            />
            <Client values={values} errors={errors} onChange={onChange} />
            <Dates values={values} errors={errors} onChange={onChange} />
            <ValueCart value={values.minPrice} onChange={onChange} />
            {values.discountType === 'percentage' && (
              <MaxDiscountAmount
                value={values.maxDiscountAmount}
                type={values.maxDiscountAmountType}
                onChange={onChange}
                error={errors.maxDiscountAmount}
              />
            )}
          </Box>
        </Box>
      </Card.Body>
    </Card>
  );
}

Limits.Skeleton = LimitsSkeleton;
